const path = 'expenses/'

const list = ({ opt = {} }) => axios.get(path, opt)
const create = ({ form, opt = {} }) => axios.post(path, form, opt)
const edit = ({ pk, form, opt = {} }) => axios.put(`${path}${pk}/`, form, opt)
const show = ({ pk, opt = {} }) => axios.get(`${path}${pk}/`, opt)
const remove = ({ pk }) => axios.delete(`${path}${pk}/`)
const report = ({ start = 'null', end = 'null', opt = {} }) =>
  axios.get(`expenses/by-date/${start}/${end}`, opt)
const excel = ({ pk, params, opt = {} }) =>
  axios.get(`expenses/getExpensesExcel/${pk}/${params}`, {
    ...opt,
    responseType: 'blob'
  })
const pdf = ({ pk, params, opt = {} }) =>
  axios.get(`expenses/getExpensesPDF/${pk}/${params}`, {
    ...opt,
    responseType: 'blob'
  })

const path2 = 'expenses-category/'
const category = {
  list: ({ opt = {} }) => axios.get(path2, opt),
  create: ({ form, opt = {} }) => axios.post(path2, form, opt),
  edit: ({ pk, form, opt = {} }) => axios.put(`${path2}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${path2}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${path2}${pk}/`)
}

const path3 = 'expenses-account/'
const account = {
  list: ({ opt = {} }) => axios.get(path3, opt),
  create: ({ form, opt = {} }) => axios.post(path3, form, opt),
  edit: ({ pk, form, opt = {} }) => axios.put(`${path3}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${path3}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${path3}${pk}/`)
}

export default {
  list,
  create,
  edit,
  show,
  remove,
  excel,
  category,
  account,
  report,
  pdf
}
